/* Copyright Levelise Ltd 2019 - 2026 */
import React, { Component } from 'react';

const FleetConext = React.createContext({
	display: '',
	statusType: '',
	searchTerm: '',
	searchDrus: null,
	selectedTimeFrame: '',
	startDate: null,
	endDate: null,
	resetZoom: false,
	timezone: '',
	selectedTimezone: '',
	faultCodes: {},
	status: {},
	afStatus: {},
	aggFacilities: [],
	aggFacilityContracts: {},
	currentDataType: '',
	afSets: new Set(),
	currentDataTypeParent: '',
	allFacilities: [],
	facilitiesSortedByDruId: [],
	facilities: [],
	regionDrus: {},
	currentDrus: [],
	currentDrusForCustomerSearch: [],
	dsrAllowedStatusDrus: {},
	batterySystemSpecList: [],
	batterySystems: {},
	meteringTypes: {},
	batterySystemTypes: [],
	batterySystemDrus: {},
	selectedBatterySystemType: null,
	hwSpecList: [],
	hwTanks: {},
	hwTypes: [],
	selectedHwType: null,
	selectedSensor: '',
	dailySumAggFacilities: {},
	weeklyReports: [],
	showStatus: Boolean,
	error: null,
	customers: [],
	customerDrusRes: [],
	customerIds: '',
	customerSearchTerm: '',
	fleetCustomerIds: '',
	fleetCustomerSearchTerm: '',
	customerSearchDruId: '',
	customerSearchShowDrusList: false,
	selectedCustomer: null,
	haveSetTimezonePreference: false,
	customerFacilityUsers: [],
	fleetCustomersList: [],

	setDisplay: () => {},
	setStatusType: () => {},
	setSearchTerm: () => {},
	setSearchDrus: () => {},
	setTimezone: () => {},
	setSelectedTimezone: () => {},
	setSelectedTimeFrame: () => {},
	setStartDate: () => {},
	setEndDate: () => {},
	setResetZoom: () => {},
	setFaultCodes: () => {},
	setStatus: () => {},
	setAfStatus: () => {},
	setShowStatus: () => {},
	setDailySumAggFacilities: () => {},
	setAggregatedFacilities: () => {},
	setAggFacilityContracts: () => {},
	setCurrentDataType: () => {},
	setAfSets: () => {},
	setCurrentDataTypeParent: () => {},
	setAllFacilities: () => {},
	setFacilitiesSortedByDruId: () => {},
	setFacilities: () => {},
	setWeeklyReports: () => {},
	setRegionDrus: () => {},
	setCurrentDrus: () => {},
	setCurrentDrusForCustomerSearch: () => {},
	setDsrAllowedStatusDrus: () => {},
	setBatterySystemSpecsList: () => {},
	setBatterySystems: () => {},
	setMeteringTypes: () => {},
	setBatterySystemTypes: () => {},
	setBatterySystemDrus: () => {},
	setSelectedBatterySystemType: () => {},
	setHwSpecsList: () => {},
	setHwTanks: () => {},
	setHwTypes: () => {},
	setSelectedHwType: () => {},
	setSelectedSensor: () => {},
	setError: () => {},
	clearError: () => {},
	clearState: () => {},
	setCustomers: () => {},
	setCustomerDrusRes: () => {},
	clearCustomers: () => {},
	clearCustomerDrusRes: () => {},
	setCustomerIds: () => {},
	setCustomerSearchTerm: () => {},
	setFleetCustomerIds: () => {},
	setFleetCustomerSearchTerm: () => {},
	setCustomerSearchDruId: () => {},
	setCustomerSearchShowDrusList: () => {},
	clearCustomerIds: () => {},
	clearCustomerSearchTerm: () => {},
	clearCustomerSearchDruId: () => {},
	setHaveSetTimezonePreference: () => {},
	setSelectedCustomer: () => {},
	setCustomerFacilityUsers: () => {},
	setFleetCustomersList: () => {},

});

export default FleetConext;

export class FleetProvider extends Component {
	state = {
		display: '',
		statusType: '',
		searchTerm: '',
		searchDrus: null,
		selectedTimeFrame: '',
		startDate: null,
		endDate: null,
		resetZoom: false,
		timezone: '',
		selectedTimezone: '',
		faultCodes: {},
		status: {},
		afStatus: {},
		aggFacilities: [],
		aggFacilityContracts: [],
		currentDataType: '',
		afSets: new Set(),
		currentDataTypeParent: '',
		allFacilities: [],
		facilitiesSortedByDruId: [],
		facilities: [],
		regionDrus: {},
		dsrAllowedStatusDrus: {},
		currentDrus: [],
		currentDrusForCustomerSearch: [],
		batterySystemSpecList: [],
		batterySystems: {},
		meteringTypes: {},
		batterySystemTypes: [],
		batterySystemDrus: {},
		selectedBatterySystemType: null,
		hwSpecList: [],
		hwTanks: {},
		hwTypes: [],
		selectedHwType: null,
		selectedSensor: '',
		dailySumAggFacilities: {
			Load: 0,
			PV: 0,
			'Battery charging': 0,
			'Battery discharging': 0,
			'Grid in': 0,
			'Grid out': 0,
		},
		weeklyReports: [],
		showStatus: true,
		error: null,
		customers: [],
		customerDrusRes: [],
		customerIds: '',
		customerSearchTerm: '',
		fleetCustomerIds: '',
		fleetCustomerSearchTerm: '',
		customerSearchDruId: '',
		customerSearchShowDrusList: false,
		haveSetTimezonePreference: false,
		selectedCustomer: null,
		customerFacilityUsers: [],
		fleetCustomersList: [],

	};

	setDisplay = (display) => this.setState({ display });
	setStatusType = (statusType) => this.setState({ statusType });
	setSearchTerm = (searchTerm) => this.setState({ searchTerm });
	setSearchDrus = (searchDrus) => this.setState({ searchDrus });
	setSelectedTimeFrame = (selectedTimeFrame) => this.setState({ selectedTimeFrame });
	setStartDate = (startDate) => this.setState({ startDate });
	setEndDate = (endDate) => this.setState({ endDate });
	setResetZoom = () => this.setState({ resetZoom: !this.state.resetZoom });
	setTimezone = (timezone) => this.setState({ timezone });
	setSelectedTimezone = (selectedTimezone) => this.setState({ selectedTimezone });
	setFaultCodes = (faultCodes) => this.setState({ faultCodes });
	setStatus = (status) => this.setState({ status });
	setAfStatus = (afStatus) => this.setState({ afStatus });
	setShowStatus = (show) => this.setState({ showStatus: show });
	setAggregatedFacilities = (aggFacilities) => this.setState({ aggFacilities });
	setAggFacilityContracts = (aggFacilityContracts) => this.setState({ aggFacilityContracts });
	setAllFacilities = (allFacilities) => this.setState({allFacilities});
	setFacilitiesSortedByDruId = (facilitiesSortedByDruId) => this.setState({ facilitiesSortedByDruId })
	setFacilities = (facilities) => {
		this.setState({
			facilities,
			display: 'facility',
			selectedBatterySystemType: '',
			batterySystemTypes: [],
			searchDrus: null,
		});
	};
	setWeeklyReports = (reports) => this.setState({ weeklyReports: [...reports] });
	setCurrentDataType = (currentDataType) => this.setState({ currentDataType });
	setAfSets = (af) => {
		let currentSet = new Set(this.state.afSets);
		currentSet.add(af);
		this.setState({ afSets: currentSet });
	};
	setCurrentDataTypeParent = (currentDataTypeParent) => this.setState({ currentDataTypeParent });
	setRegionDrus = (regionDrus) => this.setState({ regionDrus });
	setCurrentDrus = (currentDrus) => this.setState({ currentDrus });
	setCurrentDrusForCustomerSearch = (currentDrusForCustomerSearch) => this.setState({ currentDrusForCustomerSearch });
	setDsrAllowedStatusDrus = (dsrAllowedStatusDrus) => this.setState({ dsrAllowedStatusDrus });
	setBatterySystemSpecsList = (batterySystemSpecList) => this.setState({ batterySystemSpecList });
	setBatterySystems = (batterySystems) => this.setState({ batterySystems });
	setMeteringTypes = (meteringTypes) => this.setState({ meteringTypes });
	setBatterySystemTypes = (batterySystemTypes) => this.setState({ batterySystemTypes });
	setBatterySystemDrus = (batterySystemDrus) => this.setState({ batterySystemDrus });
	setSelectedBatterySystemType = (selectedBatterySystemType) => this.setState({ selectedBatterySystemType });
	setHwSpecsList = (hwSpecList) => this.setState({ hwSpecList });
	setHwTanks = (hwTanks) => this.setState({ hwTanks });
	setHwTypes = (hwTypes) => this.setState({ hwTypes });
	setSelectedHwType = (selectedHwType) => this.setState({ selectedHwType });
	setSelectedSensor = (selectedSensor) => this.setState({ selectedSensor });

	setDailySumAggFacilities = (type, value) => {
		let dailySums = { ...this.state.dailySumAggFacilities };
		dailySums[type] = dailySums[type] + value;
		this.setState({ dailySumAggFacilities: dailySums });
	};

	setCustomers = (customers) => this.setState({ customers });
	setCustomerDrusRes = (customerDrusRes) => this.setState({ customerDrusRes });

	clearCustomers = () => this.setState({ customers: [] });
	clearCustomerDrusRes = () => this.setState({ customerDrusRes: [] });

	setCustomerIds = (customerIds) => this.setState({ customerIds });
	clearCustomerIds = () => this.setState({ customerIds: '' });

	setCustomerSearchTerm = (customerSearchTerm) => this.setState({ customerSearchTerm });
	clearCustomerSearchTerm = () => this.setState({ customerSearchTerm: '' });

	setFleetCustomerIds = (fleetCustomerIds) => this.setState({ fleetCustomerIds });
	setFleetCustomerSearchTerm = (fleetCustomerSearchTerm) => this.setState({ fleetCustomerSearchTerm });

	setCustomerSearchDruId = (customerSearchDruId) => this.setState({ customerSearchDruId });
	clearCustomerSearchDruId = () => this.setState({ customerSearchDruId: '' });

	setCustomerSearchShowDrusList = (customerSearchShowDrusList) => this.setState({ customerSearchShowDrusList })

	setHaveSetTimezonePreference = (bool) => this.setState({ haveSetTimezonePreference: bool });

	setSelectedCustomer = (customer) => this.setState({ selectedCustomer: customer });

	setCustomerFacilityUsers = (customerFacilityUsers) => this.setState({ customerFacilityUsers });

	setFleetCustomersList = (arr) => this.setState({ fleetCustomersList: arr });

	clearState = () => {
		this.setState({
			display: '',
			statusType: '',
			searchTerm: '',
			searchDrus: null,
			selectedTimeFrame: '',
			startDate: null,
			endDate: null,
			resetZoom: false,
			timezone: '',
			selectedTimezone: '',
			faultCodes: {},
			status: {},
			afStatus: {},
			aggFacilities: [],
			aggFacilityContracts: [],
			currentDataType: '',
			afSets: new Set(),
			currentDataTypeParent: '',
			allFacilities: [],
			facilitiesSortedByDruId: [],
			facilities: [],
			regionDrus: {},
			dsrAllowedStatusDrus: {},
			currentDrus: [],
			currentDrusForCustomerSearch: [],
			batterySystemSpecList: [],
			batterySystems: {},
			meteringTypes: {},
			batterySystemTypes: [],
			batterySystemDrus: {},
			selectedBatterySystemType: null,
			hwSpecList: [],
			hwTanks: {},
			hwTypes: [],
			selectedHwType: null,
			dailySumAggFacilities: {
				Load: 0,
				PV: 0,
				'Battery charging': 0,
				'Battery discharging': 0,
				'Grid in': 0,
				'Grid out': 0,
			},
			weeklyReports: [],
			showStatus: true,
			error: null,
			customerFacilityUsers: [],
			selectedCustomer: null,
			fleetCustomersList: [],
			customerSearchShowDrusList: false,
			fleetCustomerIds: '',
			fleetCustomerSearchTerm: ''
		});
	};

	setError = (error) => {
		if (!this.state.error) this.setState({ error });
	};

	clearError = () => this.setState({ error: null });

	// The context value is rebuilt only when state identity changes; otherwise consumers
	// would re-render on every parent re-render because the value object would be new.
	setters = null;
	lastState = null;
	contextValue = null;

	buildSetters() {
		return {
			setDisplay: this.setDisplay,
			setStatusType: this.setStatusType,
			setSearchTerm: this.setSearchTerm,
			setSearchDrus: this.setSearchDrus,
			setTimezone: this.setTimezone,
			setSelectedTimezone: this.setSelectedTimezone,
			setSelectedTimeFrame: this.setSelectedTimeFrame,
			setStartDate: this.setStartDate,
			setEndDate: this.setEndDate,
			setResetZoom: this.setResetZoom,
			setFaultCodes: this.setFaultCodes,
			setStatus: this.setStatus,
			setAfStatus: this.setAfStatus,
			setShowStatus: this.setShowStatus,
			setAggregatedFacilities: this.setAggregatedFacilities,
			setCurrentDataType: this.setCurrentDataType,
			setAfSets: this.setAfSets,
			setCurrentDataTypeParent: this.setCurrentDataTypeParent,
			setAllFacilities: this.setAllFacilities,
			setFacilitiesSortedByDruId: this.setFacilitiesSortedByDruId,
			setFacilities: this.setFacilities,
			setAggFacilityContracts: this.setAggFacilityContracts,
			setDailySumAggFacilities: this.setDailySumAggFacilities,
			setWeeklyReports: this.setWeeklyReports,
			setRegionDrus: this.setRegionDrus,
			setCurrentDrus: this.setCurrentDrus,
			setCurrentDrusForCustomerSearch: this.setCurrentDrusForCustomerSearch,
			setDsrAllowedStatusDrus: this.setDsrAllowedStatusDrus,
			setBatterySystemSpecsList: this.setBatterySystemSpecsList,
			setBatterySystems: this.setBatterySystems,
			setMeteringTypes: this.setMeteringTypes,
			setBatterySystemTypes: this.setBatterySystemTypes,
			setBatterySystemDrus: this.setBatterySystemDrus,
			setSelectedBatterySystemType: this.setSelectedBatterySystemType,
			setHwSpecsList: this.setHwSpecsList,
			setHwTanks: this.setHwTanks,
			setHwTypes: this.setHwTypes,
			setSelectedHwType: this.setSelectedHwType,
			setSelectedSensor: this.setSelectedSensor,
			clearState: this.clearState,
			setError: this.setError,
			clearError: this.clearError,
			setCustomers: this.setCustomers,
			clearCustomers: this.clearCustomers,
			setCustomerIds: this.setCustomerIds,
			clearCustomerIds: this.clearCustomerIds,
			setCustomerSearchTerm: this.setCustomerSearchTerm,
			clearCustomerSearchTerm: this.clearCustomerSearchTerm,
			setFleetCustomerIds: this.setFleetCustomerIds,
			setFleetCustomerSearchTerm: this.setFleetCustomerSearchTerm,
			setCustomerSearchDruId: this.setCustomerSearchDruId,
			setCustomerSearchShowDrusList: this.setCustomerSearchShowDrusList,
			clearCustomerSearchDruId: this.clearCustomerSearchDruId,
			setCustomerDrusRes: this.setCustomerDrusRes,
			clearCustomerDrusRes: this.clearCustomerDrusRes,
			setHaveSetTimezonePreference: this.setHaveSetTimezonePreference,
			setSelectedCustomer: this.setSelectedCustomer,
			setCustomerFacilityUsers: this.setCustomerFacilityUsers,
			setFleetCustomersList: this.setFleetCustomersList,
		};
	}

	render() {
		if (this.state !== this.lastState) {
			if (!this.setters) this.setters = this.buildSetters();
			this.lastState = this.state;
			// State keys mirror the published context keys 1:1, so spreading state
			// reproduces the previous explicit field list.
			this.contextValue = { ...this.state, ...this.setters };
		}
		return <FleetConext.Provider value={this.contextValue}>{this.props.children}</FleetConext.Provider>;
	}
}
